import { TrimEditableImage } from '../../../image-edit/trim.editable-image';
import { TrimCjBitmap, TrimCjContainer, TrimCjShape } from '../../../../model/cj-factory';
import { TrimUiManager } from '../../../ui/trim.ui.manager';
import { TrimCjTool } from '../../../../../utilities/trim.cj-tool';
import createjs from 'createjs-module';
import * as lodash from 'lodash';
import { CJ_CONTAINER_NAME, CJ_DPOBJ_NAME } from '../../../../model/cj-factory/trim.cj-obj-name.collection';
import { cloneDeep } from 'lodash';
import { store } from '../../../../../app/store';
import { apiActions } from '../../../../../slices/api-slice';
import { ApiImagesGetOne } from '../../../../../api/front/images/api-images';
import { ThumbCreatorManager } from '../thumb.creator.manager';
import { ThumbTempCreator } from './thumb.temp.creator';
import { FitChecker } from '../../../../../utilities/fit-checker';
import { TrimDataManager } from '../../../data/trim-data.manager';
import { TrimPrintManager } from '../../../../print/trim.print';

export class ThumbImageCreator {
  public fitNum = 5;
  public imageSetMode: 'in' | 'out' | 'eq' = 'out';
  public images: TrimEditableImage[] = [];
  public static saveBlob: { blob: Blob, url: string } | null = null;

  private stage: TrimCjContainer;

  private thumbCreatorManager!: ThumbCreatorManager;
  private thumbTempCreator!: ThumbTempCreator;
  private printManager!: TrimPrintManager;

  constructor(stage: TrimCjContainer) {
    this.stage = stage;
  }

  initialize(): void {
  }

  destroy(): void {
    this.images = [];
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  di(
    thumbTempCreator: ThumbTempCreator,
    printMng: TrimPrintManager,
    thumbCreatorMng: ThumbCreatorManager,
  ): void {
    this.thumbTempCreator = thumbTempCreator;
    this.printManager = printMng;
    this.thumbCreatorManager = thumbCreatorMng;
  }


  // - 写真の生成 -
  async createPhotoImage(editableImage: TrimEditableImage, target: TrimCjContainer) {
    if (!editableImage) return;

    const imageArea = TrimCjTool.getImageAreaContainer(target);

    // -- 参照切り --
    const photoImage = lodash.cloneDeep(editableImage.editable);
    // -- ハイライトを透明に戻す --
    const highlight = TrimCjTool.getHighlight(target);
    if (highlight) highlight.visible = false;
    // -- マスクを作成 --
    const container = TrimCjTool.getRotateContainer(target);

    const maskContainer = TrimCjTool.getMaskContainer(target);
    const mask = maskContainer.getChildByName('mask').clone();
    mask.set({ alpha: 0, x: 0, y: 0 });
    // -- コンテナ用意 --
    const imageContainer = new TrimCjContainer();
    const photoContainer = new TrimCjContainer();
    // -- RealRect設置 --
    imageContainer.addChild(photoContainer);
    photoContainer.addChild(photoImage);
    // -- 境界情報を取得 --
    const _frameData = await TrimCjTool.checkLoad(maskContainer);
    const frameData = _frameData.getTransformedBounds();

    // -- マスク情報 --
    const _maskData = await TrimCjTool.checkLoad(mask);
    const maskData = _maskData.getBounds();
    const maskH = maskData.height;
    const maskW = maskData.width;


    // -- リサイズ（写真フィット機能込み） --
    const scale = await this.resizeImage(imageArea, editableImage, maskH, maskW);
    const containerData = imageContainer.getTransformedBounds();

    // -- 画像情報 --
    const photoH = containerData.height;
    const photoW = containerData.width;
    const scaleY = scale;
    const scaleX = scale;
    // -- 回転対応用に変数用意 --
    const _maskH = maskH;
    const _maskW = maskW;

    const y = await this.centeringImage(photoH, _maskH, scaleY);
    const x = await this.centeringImage(photoW, _maskW, scaleX);

    imageContainer.set({
      photoAreaId: editableImage.photoAreaId,
      editableImageId: editableImage.id,
      name: CJ_CONTAINER_NAME.image,
      x: maskContainer.x * 2,
      y: maskContainer.y * 2,
      regX: maskContainer.x,
      regY: maskContainer.y,
    });
    photoImage.set({
      // x: -x,
      // y: -y,
      name: CJ_DPOBJ_NAME.image,
    });

    const photoData = photoContainer.getTransformedBounds();
    photoContainer.set({
      photoAreaId: editableImage.photoAreaId,
      editableImageId: editableImage.id,
      copyFlag: false,
      deleteFlag: false,
      setMode: this.imageSetMode,
      real: {
        x: (imageArea.virtual?.x! - x) * (this.thumbCreatorManager.templateReal.w / this.thumbCreatorManager.templateVirtual.w),
        y: (imageArea.virtual?.y! - y) * (this.thumbCreatorManager.templateReal.w / this.thumbCreatorManager.templateVirtual.w),
        width: Number(editableImage.virtualWidth) * scale * (this.thumbCreatorManager.templateReal.w / this.thumbCreatorManager.templateVirtual.w),
        height: Number(editableImage.virtualHeight) * scale * (this.thumbCreatorManager.templateReal.w / this.thumbCreatorManager.templateVirtual.w),
      },
      virtual: {
        x: imageArea.virtual?.x! - x,
        y: imageArea.virtual?.y! - y,
        width: Number(editableImage.virtualWidth) * scale,
        height: Number(editableImage.virtualHeight) * scale,
      },
      selectImageSize: {
        width: editableImage.realWidth,
        height: editableImage.realHeight,
      },
      // 写真に連番？
      photoSeqNo: 0,
      // orderSelect.xmlから取得
      realPath: editableImage.path,
      selectID: editableImage.selectId,
      name: CJ_CONTAINER_NAME.photo,
      // x: - x + a/2,
      // y: - y + b/2,
      x: (photoData.width / 2) * scale - x,
      y: (photoData.height / 2) * scale - y,
      regX: (photoData.width / 2),
      regY: (photoData.height / 2),
      differPos: {
        x: 0,
        y: 0,
      },
    });
    photoContainer.originalBounds.width = photoData.width;
    photoContainer.originalBounds.height = photoData.height;
    photoContainer.originalBounds.x = cloneDeep(photoContainer.x);
    photoContainer.originalBounds.y = cloneDeep(photoContainer.y);
    photoContainer.defaultPos.x = cloneDeep(photoContainer.x);
    photoContainer.defaultPos.y = cloneDeep(photoContainer.y);

    photoContainer.scaleY = scale;
    photoContainer.scaleX = scale;

    // -- チェッカーの生成 --
    const checker = new TrimCjShape();
    checker.graphics.f('red').dr(0, 0, photoData.width, photoData.height);
    checker.set({
      name: CJ_DPOBJ_NAME.checker,
      alpha: 0,
      mouseEnabled: false,
    });
    photoContainer.addChild(checker);

    console.log(photoContainer);

    // -- 画像の追加 --
    imageContainer.mouseEnabled = false;
    container.addChild(imageContainer);
    imageArea.isComposited = true;
    const containerLength = container.numChildren;
    imageArea && container.setChildIndex(imageArea, containerLength - 1);
    FitChecker.checkImageOneOutBounds(photoContainer);


    // -- マスクの反映処理 --
    maskContainer.alpha = 0;
    mask.cache(0, 0, frameData.width, frameData.height);
    imageContainer.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas as HTMLCanvasElement)];
    imageContainer.cache(0, 0, frameData.width, frameData.height);

  }

  // - 画像を中心に配置する -
  async centeringImage(imageSize: number, maskSize: number, imageScale: number) {
    if (!maskSize || imageSize * imageScale === maskSize) return 0;
    // return (imageSize - maskSize) / 2;
    return (imageSize * imageScale - maskSize) / 2;
  }

  // - 初期サイズの変更 -
  async resizeImage(imageArea: TrimCjContainer, editableImage: TrimEditableImage, minHeight: number, minWidth: number) {
    const printTrimData = this.printManager.printTrimData;
    if (!minHeight || !minWidth || !printTrimData?.config) return 0;

    // -- フレームへの収まり具合で処理を分岐 --
    const image = editableImage.editable;
    const imageData = image.getBounds();
    const fitNum = this.fitNum * 2;
    let scaleX = (minWidth + fitNum) * image.scaleX / imageData.width!;
    let scaleY = (minHeight + fitNum) * image.scaleY / imageData.height!;
    /*
     * エディタ(trim.image-controller)と同じ粒度に丸める。
     * 揃えないと、おまかせトリミングでサムネイルと発注データの拡大率が約0.45%ずれ、
     * プレビューと実際の印刷結果が食い違う。
     */
    scaleX = Math.round(scaleX * 100) / 100;
    scaleY = Math.round(scaleY * 100) / 100;
    const imageSetMode = TrimPrintManager.getTrimBaseType(printTrimData.config.trimBaseType);
    switch (imageSetMode) {
      case 'in':
        return (scaleY < scaleX ? scaleY : scaleX);
      case 'out':
        return (scaleY > scaleX ? scaleY : scaleX);
      case 'eq':
        if (editableImage) {
          const scale = Number(editableImage.originalWidth) / Number(editableImage.virtualWidth) / TrimDataManager.getAdditionalValue;
          return Math.round(scale * 100) / 100;
        }
        return 1;
    }

  }
}
